import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { Reveal, Overline } from "@/components/bits";
import { CLINIC, CONTACT } from "@/lib/site";

const SECTIONS = [
  {
    title: "Behandlingsansvarlig",
    body: `${CLINIC.name}, ${CLINIC.address}, ${CLINIC.city}, er behandlingsansvarlig for personopplysningene som behandles i forbindelse med våre tjenester. Du kan kontakte oss på ${CONTACT.email} dersom du har spørsmål om hvordan vi behandler personopplysninger.`,
  },
  {
    title: "Hvilke opplysninger vi behandler",
    body: "Vi behandler opplysninger du selv gir oss, for eksempel når du booker time, tar kontakt på e-post eller telefon, eller kommer til behandling. Dette kan være navn, kontaktinformasjon og helseopplysninger som er nødvendige for å kunne tilby deg trygg og forsvarlig behandling.",
  },
  {
    title: "Timebestilling",
    body: "Timebestilling skjer via vårt eksterne bookingsystem (Physica). Når du booker time, registreres opplysningene dine i dette systemet. Vi anbefaler at du også leser bookingsystemets egen personvernerklæring.",
  },
  {
    title: "Pasientjournal og taushetsplikt",
    body: "Som helsepersonell har våre behandlere taushetsplikt og plikt til å føre pasientjournal i tråd med helsepersonelloven og pasientjournalloven. Journalopplysninger oppbevares sikkert og deles ikke med andre uten ditt samtykke, med mindre det følger av lov.",
  },
  {
    title: "Dine rettigheter",
    body: "Du har rett til innsyn i hvilke opplysninger vi har om deg, og du kan kreve retting eller sletting av opplysninger der dette ikke er i strid med lovpålagte oppbevaringsplikter. Du har også rett til å klage til Datatilsynet dersom du mener vi behandler personopplysninger i strid med regelverket.",
  },
  {
    title: "Informasjonskapsler",
    body: "Dette nettstedet bruker kun teknisk nødvendige informasjonskapsler. Vi bruker ikke informasjonskapsler til markedsføring eller sporing uten ditt samtykke.",
  },
];

export default function Personvern() {
  return (
    <>
      <Seo
        title="Personvern | Actus Osteopati – Oslo sentrum"
        description="Personvernerklæring for Actus Osteopati. Les om hvordan vi behandler personopplysninger, pasientjournal og dine rettigheter."
      />
      <PageHeader
        overline="Actus Osteopati"
        title="Personvern"
        lead="Vi tar personvernet ditt på alvor. Her kan du lese om hvordan vi samler inn, bruker og beskytter personopplysninger."
        testId="personvern-heading"
      />

      <section data-testid="personvern-content" className="bg-paper py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-12 gap-12">
            <div className="md:col-span-4">
              <Reveal>
                <Overline>Personvernerklæring</Overline>
                <h2 className="font-display font-light text-3xl md:text-4xl leading-tight">
                  Slik behandler vi dine opplysninger
                </h2>
              </Reveal>
            </div>
            <div className="md:col-span-7 md:col-start-6">
              {SECTIONS.map((s, i) => (
                <Reveal key={s.title} delay={i * 0.05}>
                  <div className="py-8 border-t border-ink/10">
                    <h3 className="font-display font-normal text-xl md:text-2xl">{s.title}</h3>
                    <p className="mt-3 text-base text-ink-soft leading-relaxed">{s.body}</p>
                  </div>
                </Reveal>
              ))}
              <Reveal delay={0.2}>
                <p className="mt-8 text-sm text-ink-soft/70">
                  Spørsmål om personvern? Kontakt oss på{" "}
                  <a
                    data-testid="personvern-email-link"
                    href={`mailto:${CONTACT.email}`}
                    className="underline underline-offset-4 decoration-ink/30 hover:decoration-ink transition-colors duration-300"
                  >
                    {CONTACT.email}
                  </a>
                  .
                </p>
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
